import React from "react";

class CookiePolicy extends React.Component {
    constructor(props) {
        super(props);
        // this.state = {
        //     classes: ""
        // };
        this.cookieBox = React.createRef();

        this.getCookie = this.getCookie.bind(this);
        this.setCookie = this.setCookie.bind(this);
        this.hide = this.hide.bind(this);
        this.exit = this.exit.bind(this);
    }

    getCookie(cname) {
        var name = cname + "=";

        var decodedCookie = decodeURIComponent(document.cookie);

        var ca = decodedCookie.split(";");

        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();

        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();

        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    hide() {
        // this.setState({classes: ""});
        this.setCookie("LabXAllowedCookies", "true", 365);
        this.cookieBox.current.parentElement.classList.remove("cookie--show");
    }

    exit() {
        // this.setState({classes: ""});
        this.cookieBox.current.parentElement.classList.remove("cookie--show");
    }

    componentDidMount() {
        let cookie = this.getCookie("LabXAllowedCookies");

        if(cookie !== "true") {
            // this.setState({classes: "cookie--show"});
            this.cookieBox.current.parentElement.classList.add("cookie--show");
        }
    }

    render() {
        return (
            <div ref={this.cookieBox} className="cookie__row">
                <div className="cookie__text">
                    <p>We’ve updated our <a href="/cms/privacy-policy" className="cookie__a">Privacy Policy</a> to make it clearer how we use your personal data.</p>
                    <p>Please read our <a href="/cms/cookie-policy" className="cookie__a">Cookie Policy</a> to learn how we use cookies to provide you with a better experience.</p>
                </div>
                <button className="cookie__button" onClick={this.hide}>ACCEPT</button>
                <div className="cookie__close" onClick={this.exit}>
                    <i className="fas fa-times-circle"></i>
                    <span className="sr-only">Close Accept cookie notification</span>
                </div>
            </div>
        );
    }
}

export default CookiePolicy;